export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 140,
    slots: {
      default: 'opt'
    }
  },
  {
    title: '开料单编号',
    field: 'techCuttingNo',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: '开料单名称',
    field: 'techCuttingName',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: '开料单状态',
    width: 100,
    align: 'center',
    slots: { default: 'status' }
  },
  {
    title: '订单编号',
    field: 'orderNo',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: '客户订单编号',
    field: 'custOrderNo',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: '下单客户',
    field: 'custName',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: '终端客户',
    field: 'endCustName',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },

  {
    title: '业务人员名字',
    field: 'salesPersonName',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true
  },
  {
    title: '订单类型',
    field: 'v_orderType',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: '订单来源',
    field: 'v_orderSource',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: '执行方式',
    field: 'v_orderExecuteType',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: '执行工厂',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  // {
  //   title: that.$l('form_label_productLine') || '产品线',
  //   field: 'v_productLine',
  //   width: 120,
  //   headerAlign: 'center',
  //   align: 'center',
  //   showHeaderOverflow: true
  // },
  {
    title:  '审核人',
    field: 'reviewByName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'reviewInfo' }
  },
  {
    title: that.$l('INDEX.creator') || '创建人',
    field: 'createByName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    minWidth: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' }
  },
]
